let autocomplete, mapita, realMarker;

function initMap() {
  const mapaContainer = document.getElementById("mapitaCool");
  const urlchida = document.getElementById("url_chida");

  if (!mapaContainer || !urlchida) {
    console.error("Error: Elementos del mapa no encontrados.");
    return;
  }

  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById("autocomplete"),
    { types: ["geocode"] }
  );

  autocomplete.setFields(["address_component", "formatted_address", "place_id", "url", "geometry"]);

  mapita = new google.maps.Map(mapaContainer, {
    center: { lat: -17.749642, lng: -63.169050 },
    zoom: 15,
    gestureHandling: "greedy",
    fullscreenControl: false
  });

  if (window.innerWidth <= 600) {
    mapaContainer.style.height = "450px";
  } else {
    mapaContainer.style.height = "400px";
  }

  const fakeMarker = document.createElement('div');
  fakeMarker.innerHTML = `
    <svg height="80px" width="70px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <g id="_x31_57_x2C__Twitter_x2C__Location_x2C__Map">
        <g>
          <path d="M256.08,54.999c84.87,0,153.81,68.94,153.81,153.96c0,77.059-87.02,195.03-153.2,246.04 c-85.33-69.24-154.58-167.75-154.58-246.04C102.11,123.938,171.05,54.999,256.08,54.999z M330.87,205.798 c0-41.34-33.521-74.86-74.87-74.86c-41.35,0-74.86,33.52-74.86,74.86c0,41.35,33.51,74.87,74.86,74.87 C297.35,280.668,330.87,247.148,330.87,205.798z" style="fill:#FF7979;"/>
        </g>
      </g>
      <g id="Layer_1"/>
    </svg>
  `;
  fakeMarker.style.position = 'absolute';
  fakeMarker.style.top = '50%';
  fakeMarker.style.left = '50%';
  fakeMarker.style.transform = 'translate(-50%, -70%)';
  fakeMarker.style.zIndex = '1';
  mapaContainer.appendChild(fakeMarker);

  google.maps.event.addListener(mapita, "dragend", function () {
    placeRealMarker();
  });

  function placeRealMarker() {
    const center = mapita.getCenter();
    const lat = center.lat();
    const lng = center.lng();

    if (realMarker) {
      realMarker.setMap(null);
    }

    realMarker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: mapita,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0
      }
    });

    const latitud = lat >= 0 ? convertirCoordenadas(lat) + 'N' : convertirCoordenadas(lat) + 'S';
    const longitud = lng >= 0 ? convertirCoordenadas(lng) + 'E' : convertirCoordenadas(lng) + 'W';

    urlchida.value = `https://www.google.com/maps/place/${latitud}, ${longitud}`;

    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    urlchida.dispatchEvent(event);

    calcularDistancia(lat, lng);
  }

  function convertirCoordenadas(grados) {
    const absoluto = Math.abs(grados);
    const gradosEnteros = Math.floor(absoluto);
    const minutos = (absoluto - gradosEnteros) * 60;
    const minutosEnteros = Math.floor(minutos);
    const segundos = (minutos - minutosEnteros) * 60;
    return `${gradosEnteros}°${minutosEnteros}'${segundos.toFixed(1)}"`;
  }
}

function calcularDistancia(latUsuario, lngUsuario) {
  const ubicacionUsuario = new google.maps.LatLng(latUsuario, lngUsuario);
  const puntoFijo = new google.maps.LatLng(-17.749599, -63.169074);

  const distancia = google.maps.geometry.spherical.computeDistanceBetween(ubicacionUsuario, puntoFijo);
  let distanciaKm = distancia / 1000;

  const kilometrosExtra = Math.floor(distanciaKm / 0.3125) * 0.125;
  distanciaKm += kilometrosExtra;
  distanciaKm = distanciaKm.toFixed(2);

  document.getElementById("distancia").textContent = "Distancia del envío: " + distanciaKm + " km";
  calcularPrecio(distanciaKm);
}

function geolocate() {
  const defaultLocation = { lat: -17.749642, lng: -63.169050 };
  const geolocationOptions = { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 };

  function setAutocompleteBounds(geolocation) {
    const circle = new google.maps.Circle({
      center: geolocation,
      radius: geolocation.coords ? geolocation.coords.accuracy : 10,
    });
    autocomplete.setBounds(circle.getBounds());
  }

  navigator.geolocation.getCurrentPosition(
    position => setAutocompleteBounds(position),
    error => setAutocompleteBounds(defaultLocation),
    geolocationOptions
  );
}

function calcularPrecio(distanciaKm) {
  let precio = 0;

  // Condición para asignar valores a `precio` basado en la distancia
  if (distanciaKm > 0 && distanciaKm <= 2) {
      precio = 10;
  } else if (distanciaKm <= 3) {
     precio = 10.5; 
  } else if (distanciaKm <= 3.5) {
      precio = 12;
  } else if (distanciaKm <= 4) {
      precio = 12.5;  
  } else if (distanciaKm <= 4.5) {
      precio = 14;
  } else if (distanciaKm <= 5) {
      precio = 14.5;
  } else if (distanciaKm <= 5.5) {
      precio = 16;
  } else if (distanciaKm <= 6) {
      precio = 16.5;
  } else if (distanciaKm <= 6.5) {
      precio = 18;
  } else if (distanciaKm <= 7) {
      precio = 18.5;
  } else if (distanciaKm <= 7.5) {
      precio = 20;
  } else if (distanciaKm <= 8) {
      precio = 20.5;
  } else if (distanciaKm <= 8.5) {
      precio = 22;
  } else if (distanciaKm <= 9) {
      precio = 22.5;
  } else if (distanciaKm <= 9.5) {
      precio = 24;
  } else if (distanciaKm <= 10) {
      precio = 24.5;
  } else if (distanciaKm <= 10.5) {
      precio = 26;
  } else if (distanciaKm <= 11) {
      precio = 26.5;
  } else if (distanciaKm <= 11.5) {
      precio = 28;
  } else if (distanciaKm <= 12) {
      precio = 28.5;
  } else if (distanciaKm <= 12.5) {
      precio = 30;
  } else if (distanciaKm <= 13) {
      precio = 30.5;
  } else if (distanciaKm <= 13.5) {
      precio = 32;
  } else if (distanciaKm <= 14) {
      precio = 32.5;
  } else if (distanciaKm <= 15) {
      precio = 35;
  } else if (distanciaKm <= 16) {
      precio = 35.5;
  } else if (distanciaKm <= 17) {
      precio = 38;
  } else if (distanciaKm <= 18) {
      precio = 38.5;
  } else if (distanciaKm <= 20) {
      precio = 40.5;
  }

  const precioElement = document.getElementById("precio");
  const precioNuevoElement = document.getElementById("precioNuevoId");
  const mensajeEnvio = document.getElementById("mensajeenvio");
  const cotizarElement = document.getElementById("cotizarId"); // Nuevo ID para mostrar "A cotizar"

  if (precio === 0) {
    precioElement.style.display = "none";
    precioNuevoElement.style.display = "none"; // Oculta el precio cuando es 0
    cotizarElement.style.display = "block"; // Muestra "Envio a cotizar"
    cotizarElement.textContent = "Envio a cotizar";
    mensajeEnvio.textContent = "Cotizaremos el envío al completar el pedido";
  } else {
    precioElement.style.display = "inline";
    precioNuevoElement.style.display = "block";
    cotizarElement.style.display = "none"; // Oculta "A cotizar" cuando hay precio
    mensajeEnvio.textContent = "";

    // Actualiza el precio en ambos elementos visibles
    precioElement.textContent = "Bs " + precio.toFixed(2);
    precioNuevoElement.textContent = "+ Bs " + precio.toFixed(2) + " de envío";
  }

  // Almacena el nuevo valor de `precio` en localStorage
  localStorage.setItem("precioEnvio", precio.toFixed(2));

  copiarPrecioEasyCell();
}

function copiarPrecioEasyCell() {
  var precioElement = document.getElementById('precio');
  var inputEasyCell = document.getElementById('es-text35');

  if (precioElement && inputEasyCell) {
    var precioValue = precioElement.textContent.trim();
    inputEasyCell.value = precioValue;

    var event = new Event('input', {
      bubbles: true,
      cancelable: true
    });
    inputEasyCell.dispatchEvent(event);
  }
}
